<template>
  <div>
    <footer class="footer">
      <div class="footer__main">
        <div class="footer__column">
          <div class="footer__column-title">회사 소개</div>
          <div class="hline-w"></div>
          <div class="footer__column-description">
            코더스하이는 iOS/macOS 교육 콘텐츠 제작 그룹입니다. 코더들이 짜릿한
            즐거움을 느끼도록 하는 것이우리의 목표입니다.
          </div>
        </div>
        <div class="footer__column">
          <div class="footer__column-title">관련 사이트</div>
          <div class="footer__column-icons">
            <a :href="codershighFacebook">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a :href="codershighLounge">
              <i class="fas fa-comment"></i>
            </a>
            <a :href="codershighOnline">
              <i class="fas fa-chalkboard-teacher"></i>
            </a>
          </div>
        </div>
        <div class="footer__column">
          <div class="footer__column-title">회사 위치</div>
          <div class="footer__column-description">
            서울특별시 강남구 언주로 534, 9층 (역삼동, BJ타워)
          </div>
        </div>
      </div>
      <footer class="main__bottom">
        <div>2017 ⓒ CodersHigh</div>
        <div>대표이사 윤성관 | 사업자등록번호 740-81-00581</div>
      </footer>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codershighFacebook: "https://www.facebook.com/codershighteam",
      codershighOnline: "https://codershigh.dscloud.biz/Codershigh_Online/#/",
      codershighLounge: "http://codershigh.dscloud.biz:30004/"
    };
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
@media screen and (min-width: 550px) {
  .footer {
    display: flex;
    width: 100%;
    height: 20%;
    padding: 20px 10px;
    background-color: #103f62;
    color: white;
    justify-content: center;
    flex-direction: column;
    font-size: 15px;
  }

  .footer .footer__main {
    display: flex;
    justify-content: space-around;
    align-content: center;
    font-size: 1 em;
  }
  .footer__column-description,
  .footer__column-icons {
    display: flex;
    justify-content: space-around;
    width: 100%;
    border-top: 1px solid #979797;
    padding-top: 10px;
  }

  .footer__column {
    width: 100%;
    display: flex;
    padding: 10px;
    align-items: center;
    flex-direction: column;
  }

  .footer__column-title {
    margin-bottom: 10px;
  }

  .footer__column-icons {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  .footer .main__bottom {
    display: flex;
    flex-direction: column;
    align-self: center;
  }
}
@media screen and (max-width: 550px) {
  .footer {
    display: flex;
    width: 100%;
    height: 20%;
    padding: 5px 5px;
    background-color: #103f62;
    color: white;
    justify-content: center;
    flex-direction: column;
    font-size: 12px;
  }
  .footer__column-description,
  .footer__column-icons {
    width: 100%;
    border-top: 1px solid #979797;
    padding-top: 10px;
  }

  .footer .footer__main {
    display: flex;
    justify-content: space-around;
    align-content: center;
    font-size: 1 em;
  }

  .footer__column {
    width: 100%;
    display: flex;
    padding: 10px;
    align-items: center;
    flex-direction: column;
  }

  .footer__column-title {
    margin-bottom: 10px;
  }

  .footer__column-icons {
    display: flex;
    justify-content: space-between;
  }

  .footer .main__bottom {
    display: flex;
    flex-direction: column;
    align-self: center;
  }
}

a i {
  color: #bfc9d3;
}
a i:hover {
  color: white;
}
</style>
